// A deliberately dark basemap: the dashboard around it is white, so the map reads as a
// separate instrument rather than another table, and the demand bubbles glow instead of
// competing with Google's default red POI pins.
export const DARK_MAP_STYLE = [
  { elementType: 'geometry', stylers: [{ color: '#0f172a' }] },
  { elementType: 'labels.text.fill', stylers: [{ color: '#7c8ba1' }] },
  { elementType: 'labels.text.stroke', stylers: [{ color: '#0f172a' }] },
  { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
  { featureType: 'administrative', elementType: 'geometry', stylers: [{ color: '#1e293b' }] },
  { featureType: 'administrative.country', elementType: 'geometry.stroke', stylers: [{ color: '#334155' }] },
  { featureType: 'administrative.province', elementType: 'geometry.stroke', stylers: [{ color: '#1f2b3d' }] },
  { featureType: 'administrative.locality', elementType: 'labels.text.fill', stylers: [{ color: '#94a3b8' }] },
  { featureType: 'poi', stylers: [{ visibility: 'off' }] },
  { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#1b2637' }] },
  { featureType: 'road', elementType: 'labels', stylers: [{ visibility: 'off' }] },
  { featureType: 'road.highway', elementType: 'geometry', stylers: [{ color: '#243347' }] },
  { featureType: 'transit', stylers: [{ visibility: 'off' }] },
  { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#081020' }] },
  { featureType: 'water', elementType: 'labels.text.fill', stylers: [{ color: '#334155' }] },
  { featureType: 'landscape.natural', elementType: 'geometry', stylers: [{ color: '#111e30' }] },
];

// Same palette as the unserviced-demand card: rose = we cannot serve it, emerald = we can.
export const TONE = {
  unserved: { core: '#f43f5e', halo: '#fb7185' },
  served: { core: '#10b981', halo: '#34d399' },
  inspection: '#34d399',
  service: '#38bdf8',
  approximate: '#f59e0b',
};

export const CITY_MAP_OPTIONS = {
  styles: DARK_MAP_STYLE,
  disableDefaultUI: true,
  zoomControl: true,
  gestureHandling: 'greedy',
  clickableIcons: false,
  backgroundColor: '#0f172a',
};
